import React from "react";

import FutureEstateValueCard from "./FutureEstateValueCard";
import SummaryCard from "./SummaryCard";
import ImpactCard from "./ImpactCard";
import {StateInputDto, WealthPOSummaryResponse} from "../WealthPOTypes";
import StateOfResidencyOverview from "./StateOfResidencyOverview";
import classNames from "classnames";

interface StrategySummarySectionProps {
    listOfStates: StateInputDto[];
    isInReportPreview: boolean;
    refreshStrategiesSummary: (selectedState?: string) => void;
    wealthPOSummaryResponse: WealthPOSummaryResponse;
}

const StrategySummarySection: React.FC<StrategySummarySectionProps> = ({
                                                                           listOfStates,
                                                                           isInReportPreview,
                                                                           refreshStrategiesSummary,
                                                                           wealthPOSummaryResponse
                                                                       }: StrategySummarySectionProps) => {
    const estimatedImpactSummary = wealthPOSummaryResponse.estimatedImpactSummary;

    const impactSection = <div className={"impact-section"}>
        <ImpactCard impactHeaderText={"Amount to Beneficiaries"}
                    impactValue={
                        estimatedImpactSummary.onlyStateOfResidencyStrategySelected
                            ? null
                            : estimatedImpactSummary.totalImpactToAmountToBeneficiaries
                    }
                    impactTypeClass={"amount-to-beneficiaries"}/>

        <ImpactCard impactHeaderText={"Est. Estate Tax"}
                    impactValue={estimatedImpactSummary.totalImpactToEstEstateTax}
                    impactTypeClass={"estate-tax-savings"}
        />
    </div>;

    const futureEstateValueWithStrategies = {
        totalAmountToBeneficiaries: wealthPOSummaryResponse.estateTaxBreakdownWithStrategies.beneficiaryTotalValue,
        totalEstEstateTax: wealthPOSummaryResponse.estateTaxBreakdownWithStrategies.estimatedEstateTax
    };
    const futureEstateValueWithoutStrategies = {
        totalAmountToBeneficiaries: wealthPOSummaryResponse.estateTaxBreakdownWithoutStrategies.beneficiaryTotalValue,
        totalEstEstateTax: wealthPOSummaryResponse.estateTaxBreakdownWithoutStrategies.estimatedEstateTax
    };

    return (<div data-testid={"strategy-summary-section"}>

                <SummaryCard hasSORCard={true} futureEstateValueWithStrategies={futureEstateValueWithStrategies}/>
                <section className={
                    classNames("estimated-impact-summary-section",
                        "estimated-impact-summary-section-with-sor-card")
                }>
                    <FutureEstateValueCard
                        futureEstateValueWithoutStrategies={futureEstateValueWithoutStrategies}
                        futureEstateValueWithStrategies={futureEstateValueWithStrategies}
                    />
                    <div className={classNames("summary-container", "summary-container-with-sor-card")}>
                        {impactSection}
                        <StateOfResidencyOverview isInReportPreview={isInReportPreview}
                                                  listOfStates={listOfStates}
                                                  selectedStateOfResidencyInfo={wealthPOSummaryResponse.stateOfResidencyStrategy}
                                                  profileStateEffectiveRate={wealthPOSummaryResponse.profileStateEffectiveRate}
                                                  refreshStrategiesSummary={refreshStrategiesSummary}
                        />
                    </div>
                </section>
        </div>
    );
}

export default StrategySummarySection;